<template>
    <div>
		<div class="card" id="card" v-on:click="clickFunction('' + slug + '', true, '' + status + '')">
            <span v-if="status === 'LIVE'" class="status text-right">
					<div class="pulse"></div>
					<span class="challenge-status">
						{{status}}
					</span>
			</span>

            <span v-else-if="status === 'ENDED'" class="status text-right">
					<div class="pulse-ended"></div>
					<span class="challenge-status-ended">
						{{status}}
					</span>
			</span>

            <span><img class="img_icon" :src='iconUrl' alt="challenge icon" />{{company}}</span>
            <div class="text-left">
            <div class="position text-left">{{position}}</div>
            <span class="exp-span"><i class="fa fa-briefcase" aria-hidden="true"></i><span class="experience text-left">{{experience}}</span><span class="location text-right"><i class="fa fa-map-marker" aria-hidden="true"></i><span class="location-text">{{location}}</span></span></span>
            </div>
        </div>
    </div>
</template>

<script>
import { StringDecoder } from 'string_decoder';
export default {
    name: 'JobCard',
    props: {
        clickFunction: Function,
        jobObj: Object,
        status: String,
        slug: String,
        position: String,
        iconUrl: String,
        company: String,
        salary: String,
        location: String,
        experience: String
    }
}
</script>


<style scoped>

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .card {
		margin-top:20px; 
		margin-bottom:20px; 
		padding-top:0px;
        padding-bottom:10px;
		margin-right: 6.25%;
		margin-left: 6.25%;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
		border-radius: 10px;
        color: #444;
	}

	.card:hover {
		box-shadow: 12px 15px 20px 0px rgba(46,61,73,0.2);
	}

	.card-container-icon {
		padding-top:20px;
	}

    .challenge-status {
		margin-right:10%;
		color:red;
		font-size:12px;
	}

    .img_icon {
        margin-top:0px;
		padding-top:10px; 
		padding-bottom:10px;
		height:90px;
		width:140px;
	}

    .position {
        font-size: 1rem;
        padding-left: 6%;
        padding-right: 6%;
        margin-bottom: 4%;
        margin-top: 2%;
    }

    .location {
        font-size: 0.8rem;
        padding-left: 0%;
        padding-right: 6%;
        padding-top:1%;
        margin-left: 32%;
    }

    .location-text {
        font-size: 0.8rem;
        padding-left: 0%;
    }

    .experience {
        font-size: 0.8rem;
        padding-left: 3%;
        padding-right: 0%;
    }

    .fa.fa-briefcase {
        font-size: 0.75rem;
        padding-left: 6%;
        padding-top:1%;
        color: #888;
    }

    .fa.fa-map-marker {
        font-size: 0.75rem;
        padding-left:0%;
        padding-right: 2%;
        padding-top: 6%;
        margin-left: 4%;
        color: #888;
    }


    .exp-span {
        position: relative;
    }

    .status {
        margin-top: 10px;
    }

</style>
